import {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

/**
 * ScrollToTop will scroll the viewport to the top whenever the current URL
 * changes. If this component doesn't meet the needs of your layout, take a look
 * at this [guide]{@link https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md}.
 *
 */
export default function ScrollToTop() {
    const {pathname, hash, key} = useLocation()

    useEffect(() => {
        // Skip scroll-to-top if the navigation includes a hash anchor
        // (useHashScroll will handle the element scrolling)
        if (hash) return

        // Scroll to top:
        // - on normal page navigation
        // - on same-page navigation triggered via <Link> (key changed)
        window.scrollTo(0, 0)
    }, [pathname, key, hash])

    return null
}
